import { getTotalCosts } from './policyChoiceHelper';
import { getOverview } from './bankHelper';

/**
 * PRO Method to calculate the spendable budget (globas)
 * @param {object} [totalGameStateSum={}] - totalGameStateSum object from gameState reducer (state.gameState.totalGameStateSum)
 * @param {object} [policyChoices={}] - policyChoices object from reducer (state.policyChoices)
 * @param {object} [ministryGlobaDivision={}] - ministerieGlobaVerdeling object from gameStateInput reducer (state.gameStateInput.myState.ministerieGlobaVerdeling)
 * @param {number} [savingAndLonas=0] - Total of savings and lonas to be added to the budget sum (!! USE calculateSavingsAndLoans method in calculationsHelper)
 * @return {number} budget (globas)
 */
function calculateBudgetPRO(gameState, gameStateInput, policyChoices = {}, ministryGlobaDivision = {}, savingsAndLoans = 0) {
  const { totalGameStateSum, history } = gameState;
  let globas = totalGameStateSum.globas;
  if (history) return globas;
  // Add policy choice costs to budget globas
  globas -= Object.values(policyChoices).reduce((acc, o) => acc + o.globas, 0);

  // Add ministry globa devision cost to budget globas
  globas -= Object.values(ministryGlobaDivision)
      .filter((i) => parseInt(i, 10))
      .reduce((acc, i) => acc + i, 0);

  // Add loans and savings to globas budget sum
  globas += savingsAndLoans;
  return globas;
}

/**
 * PRO Calculate savings and loans sum
 * @param {object} myState - myState object from gameStateInput reducer (state.gameStateInput.myState)
 * @param {array<object>} [schoolClasses=[]] - SchoolClasses array from project reducer (state.project.SchoolClasses)
 * @return {number} Total sum of savings and loans
 */
function calculateSavingsAndLoans(gameStateInput) {
  if(gameStateInput === undefined) return;
  const saveLoanOverview = getOverview(gameStateInput);
  const plus = saveLoanOverview[0].items[0].items.reduce((accumilator, current) => {
    if (!current.pending && !isNaN(parseFloat(current.points))) {
      accumilator += current.points;
    }
    return accumilator;
  }, 0);
  const min = saveLoanOverview[0].items[1].items.reduce((accumilator, current) => {
    if (!isNaN(parseFloat(current.points))) {
      if(current.key === 'lenenAanLand' && current.pending === true) {
        return accumilator;
      }
      accumilator += current.points;
    }
    return accumilator;
  }, 0);
  return plus - min;
}

/**
 * BASIC Method to calculate the spendable budget (globas)
 * @param {object} [totalGameStateSum={}] - totalGameStateSum object from gameState reducer (state.gameState.totalGameStateSum)
 * @param {object} [policyChoices={}] - policyChoices object from reducer (state.policyChoices)
 * @param {object} [ministryGlobaDivision={}] - ministerieGlobaVerdeling object from gameStateInput reducer (state.gameStateInput.myState.ministerieGlobaVerdeling)
 * @param {number} [savingAndLonas=0] - Total of savings and lonas to be added to the budget sum (!! USE calculateSavingsAndLoans method in calculationsHelper)
 * @return {number} budget (globas)
 */
function calculateBudgetBASIC({ totalGameStateSum, history }, policyChoices = {}, ministryGlobaDivision = {}, savingsAndLoans = 0, beleidskeuzes = []) {
  let globas = totalGameStateSum.globas;
  if (history) return globas;

  // @todo Add policy choice costs to budget globas
  globas -= getTotalCosts(policyChoices, beleidskeuzes);

  // Add ministry globa devision cost to budget globas
  globas -= Object.values(ministryGlobaDivision)
      .filter((i) => parseInt(i, 10))
      .reduce((acc, i) => acc + i, 0);

  // Add loans and savings to globas budget sum
  globas += savingsAndLoans;
  return globas;
}

/**
 * Calculate spent globas on ministry (this round)
 * @param {Object} ministerieGlobaVerdeling
 * @param {string} ministry
 * @param {number} currentStep
 * @param {Object[]} policyChoices
 * @returns {number} total cost
 */
function getMinistryGlobasSpent(ministerieGlobaVerdeling, ministry, currentStep, policyChoices) {
  let pcsCosts = 0;
  if (Array.isArray(policyChoices)) {
    pcsCosts = policyChoices
    .filter(pc => pc.ministry === ministry)
    .reduce((cost, pc) => {
      return cost += (pc.globas || 0);
    }, 0);
  }
  if (currentStep === 3) {
    return (ministerieGlobaVerdeling[ministry] || 0) + pcsCosts;
  }
  return;
}

function getGlobasSpent(gameStateInput, beleidskeuzes = []) {
  let spent = 0;
  if (gameStateInput.myState.niveau === 'Pro') {
    spent += Object.values(gameStateInput.myState.policyChoices).reduce((acc, o) => acc + o.globas, 0);

    // Add ministry globa devision cost to budget globas
    spent += Object.values(gameStateInput.myState.ministerieGlobaVerdeling)
      .filter((i) => parseInt(i, 10))
      .reduce((acc, i) => acc + i, 0);
  } else if (gameStateInput.myState.niveau === 'Basic') {
    spent += getTotalCosts(gameStateInput.myState.policyChoices, beleidskeuzes);

    // Add ministry globa devision cost to budget globas
    spent += Object.values(gameStateInput.myState.ministerieGlobaVerdeling)
      .filter((i) => parseInt(i, 10))
      .reduce((acc, i) => acc + i, 0);
  }
  spent -= calculateSavingsAndLoans(gameStateInput);
  return spent;
}

function getTotalPoints(group) {
  return group.Rounds.reduce((points, round) => {
    points += (round.earnedPoints || 0);
    if (Array.isArray(round.GameStates)) {
      points += round.GameStates.reduce((p, gs) => {
        p += gs.points;
      return p;
    }, 0);
    }
    return points;
  }, 0);
 }

export {
  calculateBudgetPRO,
  calculateSavingsAndLoans,
  calculateBudgetBASIC,
  getMinistryGlobasSpent,
  getGlobasSpent,
  getTotalPoints,
};



// WEBPACK FOOTER //
// ./src/helpers/calculationsHelper.js